import { createContext, useContext, useState, useEffect } from "react";
import { fetchPointsConfig } from "../config/points";

const PointsConfigContext = createContext(null);

export function PointsConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetchPointsConfig().then(setConfig);
  }, []);

  // Render children with null config — consumers fall back to hardcoded defaults
  return (
    <PointsConfigContext.Provider value={config}>
      {children}
    </PointsConfigContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function usePointsConfig() {
  const ctx = useContext(PointsConfigContext);
  return {
    POINTS_PER_ORDER:    ctx?.POINTS_PER_ORDER    ?? 25,
    POINTS_SIGNUP_BONUS: ctx?.POINTS_SIGNUP_BONUS ?? 50,
    POINTS_REFERRAL:     ctx?.POINTS_REFERRAL     ?? 50,
    POINTS_PER_DOLLAR:   ctx?.POINTS_PER_DOLLAR   ?? 15,
  };
}
